// extracted by mini-css-extract-plugin
export default {"icon":"history-mail-button_icon__Nu8B5","disabled":"history-mail-button_disabled__13MjK","placeHolderShimmer":"history-mail-button_placeHolderShimmer__XQO4d"};